"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_CLASSES_DATA = void 0;
exports.SET_CLASSES_DATA = 'SET_CLASSES_DATA';
